<template>
    <div class="week">
        <button class="week-info" @click="zoomOut(days[0])">
            <span class="week-number">{{ weekNumber }}</span>
            {{ weekInfo }}
        </button>
        <div class="days">
            <button
                class="date"
                :class="{
                    'planning-today': day.formatted == formatDate(today),
                }"
                :style="dateStyle(day)"
                v-for="day in days"
                :key="day.formatted"
                @click="zoomIn(day)"
            >
                {{ getDate(day.localDate) }}
            </button>
        </div>
    </div>
</template>

<script>
import {
    ChronoField,
    convert,
    DateTimeFormatter,
    DayOfWeek,
    TemporalAdjusters,
} from '@js-joda/core';
import { mapActions, mapState } from 'vuex';
import { ZOOM_SETTINGS } from '../../constants';

export default {
    data() {
        return {
            today: new Date(),
        };
    },
    props: ['week'],
    computed: {
        ...mapState('planning', ['currentZoom']),
        days() {
            const dateformatter = DateTimeFormatter.ofPattern('yyyy-MM-dd');

            let days = [];

            let startOfWeek = this.week;
            const endOfWeek = startOfWeek.with(TemporalAdjusters.nextOrSame(DayOfWeek.SUNDAY));

            days.push({
                localDate: startOfWeek,
                formatted: startOfWeek.format(dateformatter),
            });
            while (startOfWeek.isBefore(endOfWeek)) {
                startOfWeek = startOfWeek.plusDays(1);
                days.push({
                    localDate: startOfWeek,
                    formatted: startOfWeek.format(dateformatter),
                });
            }
            days;
            return days;
        },
        weekInfo() {
            const startOfWeek = this.week;
            const endOfWeek = startOfWeek.with(TemporalAdjusters.nextOrSame(DayOfWeek.SUNDAY));

            if (startOfWeek.monthValue() == endOfWeek.monthValue()) {
                let options = {
                    month: 'long',
                    year: 'numeric',
                };
                const jsDate = convert(startOfWeek).toDate();
                return jsDate.toLocaleDateString(window.locale, options);
            }

            let options = {
                month: 'short',
            };
            const startJsDate = convert(startOfWeek).toDate();
            const startMonth = startJsDate.toLocaleDateString(window.locale, options);

            options = {
                month: 'short',
                year: 'numeric',
            };
            const endJsDate = convert(endOfWeek).toDate();
            const endMonth = endJsDate.toLocaleDateString(window.locale, options);

            return startMonth + ' - ' + endMonth;
        },
        weekNumber() {
            return 'W' + ( this.week.isoWeekOfWeekyear() );
        },
    },
    methods: {
        ...mapActions('planning', ['zoomOut', 'zoomIn']),
        dateStyle(day) {
            const dayOfWeek = day.localDate.dayOfWeek().value();
            return {
                width: ZOOM_SETTINGS[this.currentZoom].dayWidth[dayOfWeek] + 'px',
            };
        },
        getDate(date) {
            const jsDate = convert(date).toDate();

            let options = {
                weekday: 'short',
                day: 'numeric',
            };

            return jsDate.toLocaleDateString(window.locale, options);
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
    },
};
</script>

<style lang="scss">
.week {
    box-sizing: border-box;
    line-height: 25px;
    text-transform: uppercase;
    border-left: 1px solid #6e7c7c;
    border-right: 1px solid #6e7c7c;
    margin-left: -1px;
    margin-right: -1px;
    &:last-child {
        border-right: 0;
    }
}
.week-info {
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    line-height: 25px;
    padding: 0;
    border-bottom: 1px solid #6e7c7c;
    .week-number {
        position: absolute;
        top: 0;
        left: 10px;
    }
}
.days {
    box-sizing: border-box;
    display: inline-flex;
}
.date {
    box-sizing: border-box;
    display: inline-block;
    border-right: 1px solid #ccc;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    line-height: 25px;
    padding: 0;
    &:last-child {
        border-right: 0;
    }
}
</style>
